import { render, staticRenderFns } from "./CommunityStakingCard.vue?vue&type=template&id=30706879&scoped=true&"
import script from "./CommunityStakingCard.vue?vue&type=script&lang=js&"
export * from "./CommunityStakingCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityStakingCard.vue?vue&type=style&index=0&id=30706879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30706879",
  null
  
)

export default component.exports